import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient, cacheUtils } from '../lib/query-client';

type QueryProviderProps = {
  children: React.ComponentPropsWithoutRef<typeof QueryClientProvider>['children'];
};

export function QueryProvider({ children }: QueryProviderProps) {
  useEffect(() => {
    // Listen for unauthorized events and clear the cache
    const handleUnauthorized = () => {
      cacheUtils.clearAll();
    };

    window.addEventListener('admin:unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('admin:unauthorized', handleUnauthorized);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Show devtools only in development */}
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
